import { createFileRoute } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { RbacAccessDenied } from '~/components/routes/administration/roles/access-denied'
import { RoleForm } from '~/components/routes/administration/roles/role-form'
import { useRights } from '~/utils/hooks'

export const Route = createFileRoute('/_authenticated/administration/roles/new')({
  component: AdministrationRoleCreatePage,
})

function AdministrationRoleCreatePage() {
  const isSuperAdmin = useRights(['SUPER_ADMIN'])

  if (!isSuperAdmin) {
    return <RbacAccessDenied />
  }

  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer>
        <RoleForm mode="create" />
      </AppContainer>
    </>
  )
}
